

























































































import { Component, Prop, Vue } from "@/shared/vuepack";
import {
  AccountVerificationStatus,
  accountVerificationStatusDisplayMap,
  achVerifierDisplayMap,
  bankAccountUseDisplayMap,
  LinkedAccountApi,
  LinkedBankAccountUse,
  LinkedBankAccountUseStatus,
  linkedBankAccountUseStatusDisplayMap,
} from "@/shared/types";
import { Validator } from "vee-validate";
import { accountVerificationStatusIconMap, linkedBankAccountUseStatusIconMap } from "@/shared/awesomeIconMapper";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useThemeStore } from "@/shared/store/theme";
import AccountHolderWidgetBase from "@/employer/components/partner-ee-service/AccountHolderWidgetBase.vue";
import ConsumerLinkedAccountAlert from "@/shared/components/accountAlert/ConsumerLinkedAccountAlert.vue";
import { isNullEmptyOrUndefined } from "@/shared/stringHelper";
import moment from "moment";

@Component({
  components: {
    ConsumerLinkedAccountAlert,
    AccountHolderWidgetBase
  }
})
export default class AccountHolderExternalBankAccounts extends Vue {
  $validator: Validator;
  bankAccountStore = useBankAccountStore();
  custodianSettingsStore = useCustodianSettingsStore();
  themeStore = useThemeStore();

  bankAccountUseDisplayMap = bankAccountUseDisplayMap;
  linkedBankAccountUseStatusIconMap = linkedBankAccountUseStatusIconMap;
  accountVerificationStatusIconMap = accountVerificationStatusIconMap;
  linkedBankAccountUseStatusDisplayMap = linkedBankAccountUseStatusDisplayMap;
  accountVerificationStatusDisplayMap = accountVerificationStatusDisplayMap;
  LinkedBankAccountUseStatus = LinkedBankAccountUseStatus;
  AccountVerificationStatus = AccountVerificationStatus;
  achVerifierDisplayMap = achVerifierDisplayMap;

  linkType = [
    { text: "Checking", value: "checking" },
    { text: "Savings", value: "savings" }
  ];
  init (): LinkedAccountApi {
    return {
      bankAccountName: "",
      bankAccountNumber: "",
      bankRoutingNumber: "",
      bankName: "",
      use: null,
      linkedBankAccountId: 0,
      linkedBankAccountType: "checking",
      verificationStatus: AccountVerificationStatus.Verified,
      hasPersonalContributionSchedules: false,
      isTokenizedAccountNumber: false,
      apiErrorMessage: null,
      apiErrorStatusCode: null,
      apiErrorTimestamp: null
    };
  }

  isSubmitting = false;

  @Prop({ required: true })
  username: string;

  @Prop({ required: true })
  partnerId: number;

  get allAccounts (): any[] {
    if (!this.bankAccountStore.linkedAccounts) {
      return [];
    }
    return this.bankAccountStore.linkedAccounts.sort((a, b) => a.linkedBankAccountType.localeCompare(b.linkedBankAccountType))
      .map(item => ({...item, isEdit: false, isMissingUse: item.use.accountUse === LinkedBankAccountUse.Unspecified, name: item.bankAccountName, hasError: item.apiErrorMessage !== null}));
  }
  get visibleFields () {
    return this.listFields.filter(field => field.visible === true);
  }
  get hasLinkedAccounts (): boolean {
    return this.bankAccountStore.linkedAccounts && this.bankAccountStore.linkedAccounts.length > 0;
  }
  get isConsumerLinkedAccountsInErrorState (): boolean {
    return this.bankAccountStore.isConsumerLinkedAccountsInErrorState;
  }
  loadLinkedBankAccounts () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.bankAccountStore.loadLinkedBankAccountsForUser(args);
  }
  onResync () {
    this.isSubmitting = true;
    const args = { username: this.username, partnerId: this.partnerId };
    this.bankAccountStore.reSyncLinkedBankAccounts(args);
    this.isSubmitting = false;
  }

  showErrorIcon (data) {
    return data.item.verificationStatus === AccountVerificationStatus.Failed
        || data.item.use.status === LinkedBankAccountUseStatus.Unspecified
        || data.item.use.status === LinkedBankAccountUseStatus.Inactive;
  }
  listFields = [{
    key: "bankAccountName",
    thClass: "text-left",
    tdClass: "",
    label: "Nickname",
    visible: true
  },
  {
    key: "bankAccountRouting",
    thClass: "text-left pl-1",
    tdClass: "pl-1",
    label: "Routing",
    visible: true
  },
  {
    key: "bankAccountNumber",
    thClass: "text-left pl-1",
    tdClass: "pl-1",
    label: "Account",
    visible: true
  },
  {
    key: "uses",
    label: "Use",
    thClass: "text-left",
    tdClass: "text-left",
    visible: true
  }];
  get isLoading () {
    return this.bankAccountStore.linkedAccountIsLoading || this.isSubmitting;
  }

  get isHsaBankCustodian (): boolean {
    return this.custodianSettingsStore.isHsaBankCustodian;
  }

  get isFailed () {
    return false;
  }
  loadData () {
    this.loadLinkedBankAccounts();
    const args = { username: this.username, partnerId: this.partnerId, force: true };
    this.custodianSettingsStore.getCustodianSettings(args);
  }
  getFormattedDate (date?: string): string {
    if (isNullEmptyOrUndefined(date)) {
      return "";
    }
    const local = moment.utc(date).local();
    if (isNullEmptyOrUndefined(local.zoneAbbr())) {
      return `${local.format("MM/DD/YYYY hh:mma")} ${local.tz(moment.tz.guess()).zoneAbbr()}`;
    }
    return local.format("MM/DD/YYYY hh:mma z");
  }
}
